export default __webpack_public_path__ + "static/media/isdon.c038eb9a.webp";